import * as Api from "./api";

const RESET_PASSWORD_URL = "/password/resetpassword";
const FORGOT_PASSWORD_URL = "/password/VerifyForgotPassword";

export function resetPassword(data) {
	return Api.postToApi(RESET_PASSWORD_URL, data);
}

export function forgotPassword(data) {
	return Api.postToApi(FORGOT_PASSWORD_URL, data);
}
